<template>
	<div>

		<div class="content_box">
			<div class="title">
				<span class="left_shu"></span>
				监测首页
			</div>
			<div class="gas_box">
				<div class="gas_left_box">
					<div class="gas_list" v-for="(item, index) in waterList">
						<!-- @click="getWeatherData(item.type)" -->
						<img :src="item.url">
						<div class="gas_right">
							<div class="gas_title">
								{{item.name}}
							</div>
							<div class="gas_value">
								{{item.value}}
							</div>
						</div>
					</div>
				</div>
				<div class="gas_right_box">
					<baidu-map :center="{lng:118.82814267730716, lat: 31.876923009327903}" :zoom="17"
						:scroll-wheel-zoom="true" style="width: auto; height: 100%;">
						<!-- //是否需要全景 -->
						<!-- <bm-panorama></bm-panorama> -->
						<!-- //地图类型 -->
						<!-- <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type> -->
						<bm-marker :position="markerPo"></bm-marker>
					</baidu-map>
				</div>
			</div>
		</div>
		<div class="content_box" style="margin-top: 16px;">
			<div class="title">
				<span class="left_shu"></span>
				24小时温度变化
				<div class="screen_box">
					<div class="screen_title">选择参数：</div>
					<el-select v-model="timeInterval" placeholder="请选择" @change="choiceType">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<div class="screen_title">选择时间：</div>
					<el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="choiceTime"
						:picker-options="pickerOptions">
					</el-date-picker>
					<div class="screen_title">切换设备：</div>
					<el-select v-model="deviceType" placeholder="请选择" @change="choiceType2">
						<el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="chart_box">
				<div class="chart_box_left">
					<div id="myChart1">
					</div>
				</div>
				<div class="chart_box_right">
					<div id="myChart2">
					</div>
				</div>
			</div>
			<div class="chart_box">
				<div class="chart_box_left">
					<div id="myChart5">
					</div>
				</div>
				<div class="chart_box_right">
					<div id="myChart6">
					</div>
				</div>
			</div>
			<div class="chart_box">
				<div class="chart_box_left">
					<div id="myChart3">
					</div>
				</div>
				<!-- <div class="chart_box_right">
					<div id="myChart4">
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		BmlHeatmap
	} from 'vue-baidu-map'
	export default {
		components: { //注册
			BmlHeatmap
		},
		data() {
			return {
				waterList: [{
						url: require('../../assets/image/gas1.png'),
						name: '溶氧数据-溶氧',
						value: '0',
						type: 5
					},
					{
						url: require('../../assets/image/gas2.png'),
						name: '溶氧数据-温度',
						value: '0',
						type: 6
					},
					{
						url: require('../../assets/image/gas3.png'),
						name: '电导数据-电导率',
						value: '0',
						type: 3
					},
					{
						url: require('../../assets/image/gas4.png'),
						name: '电量',
						value: '0',
						type: 4
					},
					{
						url: require('../../assets/image/gas5.png'),
						name: '酸碱度',
						value: '0',
						type: 1
					},
					{
						url: require('../../assets/image/gas6.png'),
						name: '浊度',
						value: '0',
						type: 2
					},
				],
				dataTime1: [],
				dataValue1: [],
				dataTime2: [],
				dataValue2: [],
				dataTime3: [],
				dataValue3: [],
				dataTime4: [],
				dataValue5: [],
				dataTime6: [],
				dataValue6: [],
				markerPo: {},
				options: [{
					value: 1,
					label: '半小时'
				}, {
					value: 2,
					label: '1小时'
				}, {
					value: 3,
					label: '2小时'
				}, {
					value: 4,
					label: '3小时'
				}, {
					value: 5,
					label: '6小时'
				}, {
					value: 6,
					label: '12小时'
				}, {
					value: 7,
					label: '24小时'
				}],
				deviceTypeList: [{
					value: 1,
					label: '车载'
				}, {
					value: 2,
					label: '气象站'
				}],
				deviceType: 1,
				endDate: '',
				startDate: '',
				value1: '',
				timeInterval: 1,
				control:true,
				pickerOptions: {
					onPick: ({
						maxDate,
						minDate
					}) => {
						this.selectDate = minDate.getTime()
						if (maxDate) {
							this.selectDate = ''
						}
					},
					disabledDate: time => {
						//time.getTime()获取的是时间戳
						// 当前时间往前30天可选
						// return (
						// time.getTime() > Date.now() ||
						// time.getTime() < Date.now() - 30 * 24 * 60 * 60 * 1000
						// )
						// 只能选择30天的范围且不能大于当前日期
						if (this.selectDate !== '') {
							const one = 29 * 24 * 3600 * 1000
							const minTime = this.selectDate - one
							const maxTime = this.selectDate + one
							if (maxTime > Date.now()) {
								return (
									time.getTime() < minTime ||
									time.getTime() >
									new Date(new Date().toLocaleDateString()).getTime()
								)
							} else {
								return time.getTime() < minTime || time.getTime() > maxTime
							}
						} else {
							return (
								time.getTime() >
								new Date(new Date().toLocaleDateString()).getTime()
							)
						}
					}
				}
			}
		},
		mounted() {
			const nowDate = new Date();
			const date = {
				year: nowDate.getFullYear(),
				month: nowDate.getMonth() + 1,
				date: nowDate.getDate(),
			};
			const newmonth = date.month > 9 ? date.month : "0" + date.month;
			const day = date.date > 9 ? date.date : "0" + date.date;
			this.endDate = date.year + "-" + newmonth + "-" + day;
			this.startDate = date.year + "-" + newmonth + "-" + day;
			this.getData()
			this.getWeatherData1()
			let timer1 = setTimeout(() => {
				this.getWeatherData2()
			}, 300)
			let timer2 = setTimeout(() => {
				this.getWeatherData3()
			}, 500)
			let timer3 = setTimeout(() => {
				this.getWeatherData4()
			}, 800)
			let timer4 = setTimeout(() => {
				this.getWeatherData5()
			}, 1000)
			let timer5 = setTimeout(() => {
				this.getWeatherData6()
			}, 1300)
		},
		methods: {
			async getData() {
				let result = await this.request.post("/v1.0/car/getHomeData", {
					'deviceType': this.deviceType
				});
				console.log(result.data.water)
				this.markerPo = {
					'lng': parseFloat(result.data.water.longitude) + 0.012,
					'lat': parseFloat(result.data.water.latitude) + 0.004
				}
				this.waterList[0].value = result.data.water.dissolvedOxygen
				this.waterList[1].value = result.data.water.dissolvedTemperature
				this.waterList[2].value = result.data.water.elecConductivity
				this.waterList[3].value = result.data.water.electricity
				this.waterList[4].value = result.data.water.ph
				this.waterList[5].value = result.data.water.turbidity
				if(result.data&&this.control){
					this.getData()
				}
			},
			choiceType2(e) {
				this.$notify({
					title: '切换成功',
					message: '切换成功',
					type: 'success'
				});
			},
			async getWeatherData1() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 5,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				this.dataTime1 = result.data.dataList.map(officer => officer.dataTime);
				this.dataValue1 = result.data.dataList.map(officer => officer.dataValue);
				this.drawLine1();
			},
			async getWeatherData2() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 6,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				this.dataTime2 = result.data.dataList.map(officer => officer.dataTime);
				this.dataValue2 = result.data.dataList.map(officer => officer.dataValue);
				this.drawLine2();
			},
			async getWeatherData3() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 3,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				this.dataTime3 = result.data.dataList.map(officer => officer.dataTime);
				this.dataValue3 = result.data.dataList.map(officer => officer.dataValue);
				this.drawLine3();
			},
			async getWeatherData4() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 4,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				this.dataTime4 = result.data.dataList.map(officer => officer.dataTime);
				this.dataValue4 = result.data.dataList.map(officer => officer.dataValue);
				this.drawLine4();
			},
			async getWeatherData5() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 1,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				if (result.code == 0) {
					this.dataTime5 = result.data.dataList.map(officer => officer.dataTime);
					this.dataValue5 = result.data.dataList.map(officer => officer.dataValue);
					this.drawLine5();

				}
			},
			async getWeatherData6() {
				let result = await this.request.post("/v1.0/water/getHistoryData", {
					'type': 2,
					'endDate': this.endDate,
					'startDate': this.startDate,
					'timeInterval': this.timeInterval
				});
				this.dataTime6 = result.data.dataList.map(officer => officer.dataTime);
				this.dataValue6 = result.data.dataList.map(officer => officer.dataValue);
				this.drawLine6();
			},
			choiceType(e) {
				this.getWeatherData1()
				this.getWeatherData2()
				this.getWeatherData3()
				this.getWeatherData4()
				this.getWeatherData5()
				this.getWeatherData6()
			},
			choiceTime(e) {
				this.startDate = e[0]
				this.endDate = e[1]
				this.getWeatherData1()
				this.getWeatherData2()
				this.getWeatherData3()
				this.getWeatherData4()
				this.getWeatherData5()
				this.getWeatherData6()
			},
			drawLine1() {
				let myChart1 = this.$echarts.init(document.getElementById('myChart1'))
				myChart1.setOption({
					backgroundColor: '#fff',
					title: {
						text: '溶氧数据-溶氧',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime1,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '溶氧数据-溶氧',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue1,
					}, ],
				});
			},
			drawLine2() {
				let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
				myChart2.setOption({
					backgroundColor: '#fff',
					title: {
						text: '溶氧数据-温度',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime2,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '溶氧数据-温度',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue2,
					}, ],
				});
			},
			drawLine3() {
				let myChart3 = this.$echarts.init(document.getElementById('myChart3'))
				myChart3.setOption({
					backgroundColor: '#fff',
					title: {
						text: '电导数据-电导率',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime3,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '电导数据-电导率',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue3,
					}, ],
				});
			},
			drawLine4() {
				let myChart4 = this.$echarts.init(document.getElementById('myChart4'))
				myChart4.setOption({
					backgroundColor: '#fff',
					title: {
						text: '电导数据-温度',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime4,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '电导数据-温度',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue4,
					}, ],
				});
			},
			drawLine5() {
				let myChart5 = this.$echarts.init(document.getElementById('myChart5'))
				myChart5.setOption({
					backgroundColor: '#fff',
					title: {
						text: '酸碱度',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime5,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '酸碱度',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue5,
					}, ],
				});
			},
			drawLine6() {
				let myChart6 = this.$echarts.init(document.getElementById('myChart6'))
				myChart6.setOption({
					backgroundColor: '#fff',
					title: {
						text: '浊度',
						textStyle: {
							align: 'center',
							color: '#000',
							fontSize: 16,
						},
						top: '1%',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '14%',
						left: '7%',
						right: '5%',
						bottom: '15%',
					},
					xAxis: [{
						type: 'category', //坐标轴类型
						axisLine: {
							show: true, //是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true, //是否显示刻度标签
							color: '#999', //刻度标签文字的颜色
						},

						splitLine: {
							show: false, //是否显示分隔线
						},
						axisTick: {
							show: false, //是否显示坐标轴刻度
						},
						boundaryGap: false, //坐标轴两边留白策略
						data: this.dataTime6,
					}, ],

					yAxis: [{
						type: 'value',
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4', //坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '浊度',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 5,
						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						// tooltip: {
						// 	show: false,
						// },
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: this.dataValue6,
					}, ],
				});
			},
		},
		destroyed() {
		    console.log('==离开页面==')
			this.control = false
		 },
	}
</script>

<style>
	@import url("../../assets/css/common.css");

	.gas_box {
		padding: 30px 60px 50px 60px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		position: relative;
	}

	.gas_left_box {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		position: relative;
		width: 60%;
	}

	.gas_right_box {
		width: 40%;
	}

	.gas_list {
		display: flex;
		width: 33.33%;
		height: 120px;
		align-items: center;
		justify-content: flex-start;
		padding-left: 60px;
		/* cursor: pointer; */
	}

	.gas_list:nth-child(-n+2) {
		border-right: 1px solid #D9D9D9;
	}

	.gas_list:nth-child(-n+3) {
		border-bottom: 1px solid #D9D9D9;
	}

	.gas_list:nth-child(n+4) {
		border-right: 1px solid #D9D9D9;
	}

	.gas_list:last-child {
		border: none;
	}

	.gas_list img {
		width: 70px;
		height: 70px;
	}

	.gas_right {
		padding-left: 20px;
	}

	.gas_right .gas_title {
		line-height: 30px;
		font-size: 14px;
		color: #999;
	}

	.gas_right .gas_value {
		color: #666;
		font-size: 18px;
		font-weight: bold;
	}

	.gas_right .gas_value span {
		font-size: 12px;
		font-weight: 400;
	}

	#myChart1,
	#myChart2,
	#myChart3,
	#myChart4,
	#myChart5,
	#myChart6 {
		height: 230px;
	}

	.screen_box {
		display: flex;
		width: 90%;
		float: right;

	}

	.screen_box .el-date-editor .el-range-separator {
		width: 20px;
	}

	.screen_title {
		font-size: 12px;
		color: #666;
		padding: 0 15px;
	}

	.chart_box {
		display: flex;
		padding: 10px 0;
	}

	.chart_box_left {
		width: 50%;
		height: 200px;
	}

	.chart_box_right {
		width: 50%;
		height: 200px;
	}
</style>
